import React, { useEffect } from 'react'
import Booking from '../components/Booking'

const BookingPages = () => {
  return <Booking />
}

export default BookingPages
